export default __webpack_public_path__ + "static/progress-mode-61d5623322fe463de20f86ae16d657cf.png";